/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactRoleMapping } from './ContactRoleMapping.js';
import {
    ContactRoleMappingFromJSON,
    ContactRoleMappingFromJSONTyped,
    ContactRoleMappingToJSON,
} from './ContactRoleMapping.js';

/**
 * 
 * @export
 * @interface UpdateContactRoleMappingRequest
 */
export interface UpdateContactRoleMappingRequest {
    /**
     * 
     * @type {Array<ContactRoleMapping>}
     * @memberof UpdateContactRoleMappingRequest
     */
    mappings?: Array<ContactRoleMapping>;
}

/**
 * Check if a given object implements the UpdateContactRoleMappingRequest interface.
 */
export function instanceOfUpdateContactRoleMappingRequest(value: object): boolean {
    return true;
}

export function UpdateContactRoleMappingRequestFromJSON(json: any): UpdateContactRoleMappingRequest {
    return UpdateContactRoleMappingRequestFromJSONTyped(json, false);
}

export function UpdateContactRoleMappingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContactRoleMappingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mappings': json['mappings'] == null ? undefined : ((json['mappings'] as Array<any>).map(ContactRoleMappingFromJSON)),
    };
}

export function UpdateContactRoleMappingRequestToJSON(value?: UpdateContactRoleMappingRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'mappings': value['mappings'] == null ? undefined : ((value['mappings'] as Array<any>).map(ContactRoleMappingToJSON)),
    };
}

